// src/constants/common.js

export const AvailablePurposes = ["Event", "Survey"];

export const CommonRegexPatterns = [
  {
    label: "Email",
    value: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z0-9]{1,}$",
    example: "name@example.com",
  },
  {
    label: "Integer",
    value: "^[0-9]+$",
    example: "123",
  },
  {
    label: "Phone Number",
    value: "^[0-9]{1,}$",
    example: "",
  },
  {
    label: "Phone Number with Areacode",
    value: "^\\+?[0-9]*-?[0-9]+$",
    example: "",
  },
  {
    label: "HKID",
    value: "^[A-Z]{1,2}[0-9]{6}\\([0-9A]\\)$",
    example: "A123456(7)",
  },
];

export const Languages = [
  { code: "en", name: "English" },
  { code: "tc", name: "繁體中文" },
  { code: "sc", name: "简体中文" },
];

export const AvailableTemplates = ["default", "theme1", "theme2"];

export const AreaCodeMaxLength = 8;

export const ENABLE_EXPERIMENTAL_FEATURE = true;
